// ASSETS
import defaultPlaceholderImage from "../../../../../assets/empty-image.png";
import compassPlaceholderImage from "../../../../../assets/compassImgLogo.svg";

const getPlaceholderImage = (hostName: string) => {
	if (hostName == "COMPASS") {
		return compassPlaceholderImage;
	} else {
		return defaultPlaceholderImage;
	}
};

export default getPlaceholderImage;
